const ROUTES = {
  HOME: '/',
  DEFAULT: 'default',
  INDEX: 'index',
  DASHBOARD: 'dashboard',
  // ORDER: 'order',
  // ORDER_DETAIL: 'order-detail',
  LOGIN: 'login',
  NOT_AUTHORIZED: 'not-authorized',
  SAMPLE_PAGE: 'sample-page',
  UTILS: 'utils',
  // Add more routes here as needed
  UTILS_CHILD: {
    TYPOGRAPHY: 'util-typography',
    COLOR: 'util-color',
    SHADOW: 'util-shadow',
    INPUT: 'util-input'
    // Add more utility routes here as needed
  },
  STATISTICAL: 'statistical',
  STATISTICAL_CHILD: {
    REQUEST: 'request',
    BASE_PRICE: 'base-price'
  },
  //Customer
  CUSTOMER: 'customer',
  CUSTOMER_ADD: 'customer-add',
  CUSTOMER_DETAIL: 'customer-detail',
  CUSTOMER_DETAIL_ID: 'customer-detail/:id',
  //Customer
  STAFF: 'staff',
  STAFF_DETAIL: 'staff/:id',
  //Company
  COMPANY: 'company',
  COMPANY_CHILD: {
    CAR: 'car',
    CAR_DETAIL: 'car/:id',
    DRIVER: 'driver',
    DRIVER_DETAIL: 'driver/:id',
    COST_OLI: 'cost_oli',
    COST_REPAIR: 'cost_repair',
    COST_GENERAL: 'cost_general',
    COST_ROAD: 'cost_road',
    COST_BONUS: 'cost_bonus',
    NORMS_SALARY_MONTH: 'norms-salary-month',
    NORMS_SALARY_ORDERS: 'norms-salary-orders',
    NORMS_DEGRADATION: 'norms-degradation'
  },
  //Category
  CATEGORY: 'category',
  CATEGORY_CHILD: {
    STAFF: 'staff',
    STAFF_TYPE: 'staff-type',
    STAFF_DETAIL: 'staff/:id',
    PARTER: 'partner',
    COMPANY: 'company',
    COMPANY_CAR: 'car-company',
    SHELL_TYPE: 'shell-type',
    CAR_TYPE: 'car-type',
    SHIPPING_LINES: 'shipping-lines',
    CURRENCY: 'currency',
    ORDER_TYPE: 'order-type',
    PAYMENT_METHOD: 'payment-method',
    LOCATION: 'location',
    WORKER: 'worker',
    WORKER_DETAIL: 'worker/:id',
    SALARY_ADVANCE: 'salary-advance',
    SALARY_REFUND: 'salary-refund',
    SALARY_PAY_STAFF: 'salary-pay/staff',
    SALARY_PAY_EMPLOYEE: 'salary-pay/employee'
  },
  //order
  ORDER: 'order',
  ORDER_CHILD: {
    ORDER_LIST: 'list',
    ORDER_LIST_KT: 'list-kt',
    ORDER_ORDER_NEW: 'add-order-new',
    ORDER_ORDER_FAST: 'add-order-fast',
    ORDER_ORDER_FAST_UUID: 'add-order-fast/:uuid',
    ORDER_DETAIL: 'order-detail',
    ORDER_DETAIL_ID: 'order-detail/:id',
    ORDER_DETAIL_KT: 'order-detail-kt',
    ORDER_DETAIL_KT_ID: 'order-detail-kt/:id',
    ORDER_UPDATE: 'order-update',
    ORDER_UPDATE_ID: 'order-update/:id',
    ORDER_CONNECT: 'order-connect',
    ORDER_CONNECT_ID: 'order-connect/:idConnect',
    //Lô hàng
    ORDER_SHIPMENT: 'shipment',
    ORDER_SHIPMENT_KT: 'shipment-kt',
    ORDER_SHIPMENT_DETAIL: 'shipment-detail',
    ORDER_SHIPMENT_DETAIL_ID: 'shipment-detail/:id',
    ORDER_SHIPMENT_DETAIL_KT: 'shipment-detail-kt',
    ORDER_SHIPMENT_DETAIL_KT_ID: 'shipment-detail-kt/:id',
    ORDER_SHIPMENT_ADD_ORDER: 'order-shipment',
    ORDER_SHIPMENT_ADD_ORDER_ID: 'order-shipment/:orderGroupId',
    //Điều phối
    ORDER_TRANSPORTCOORDINATION: 'transportCoordination',
    ORDER_TRANSPORTCOORDINATION_UPDATE: 'transportCoordination-update',
    ORDER_TRANSPORTCOORDINATION_UPDATE_ID: 'transportCoordination-update/:id',
    ORDER_MAINTENANCE_SCHEDULE: 'maintenance-schedule',
    ORDER_REGISTRATIONINSPECTION_SCHEDULE: 'registration-inspection-schedule',
    ORDER_VACATION_SCHEDULE: 'vacation-schedule'
  },
  //Báo cáo
  REPORT: 'report',
  REPORT_CHILD: {
    REPORT_KT: 'report-kt',
    REPORT_CHECK_LIST: 'report-check-list',
    REPORT_CHECK_LIST_DETAIL: 'report-check-list-detail',
    REPORT_CHECK_LIST_DETAIL_ID: 'report-check-list-detail/:id',
    PROFIT_REPORT: 'profit-report',
    ANALYTICS: 'analytics'
  },
  //Tài chính
  FINANCE: 'finance',
  FINANCE_CHILD: {
    ADVANCE: 'advance',
    ADD_ADVANCE_NEW: 'add-advance-new',
    ADVANCE_DETAIL: 'advance-detail',
    ADVANCE_DETAIL_ID: 'advance-detail/:id',
    OFFER_TO_PAY: 'offer-to-pay',
    ADD_OFFER_TO_PAY_NEW: 'add-offer-to-pay-new',
    OFFER_TO_PAY_DETAIL: 'offer-to-pay-detail',
    OFFER_TO_PAY_DETAIL_ID: 'offer-to-pay-detail/:id',
    REIMBURSE: 'reimburse',
    ADD_REIMBURSE_NEW: 'add-reimburse-new',
    REIMBURSE_DETAIL: 'reimburse-detail',
    REIMBURSE_DETAIL_ID: 'reimburse-detail/:id',
    CUSTOMER_DEBT: 'customer-debt',
    CASH_BOOK: 'cash-book'
  }
}

export default ROUTES
